export enum AppMode {
    PATIENT_JOURNEY = 'patientJourney',
    PATIENT_REGISTRY = 'patientRegistry',
}
